import * as React from 'react'

import { Button, Flex, Heading, Label, Textarea } from '@buffer-mono/popcorn'

import { ErrorMessage } from '~publish/legacy/ai/components/GenerateIdeasButton/ErrorMessage'
import {
  getPrompt,
  setPromptSettings,
  getPromptSettings,
} from '~publish/legacy/ai/helpers/localStorage'
import { selectGeneratedIdeas } from '~publish/legacy/ai/state/contentIdeation/slice'
import { generateIdeas } from '~publish/legacy/ai/state/contentIdeation/thunks'
import { useAppSelector, useAppDispatch } from '~publish/legacy/store'

import styles from './Questions.module.css'
/**
 *
 */
const Questions = (): React.JSX.Element => {
  const [about, setAbout] = React.useState<string>('')
  const [targetAudience, setTargetAudience] = React.useState<string>('')

  const dispatch = useAppDispatch()

  const { generateIdeasLoading, generateIdeasError } = useAppSelector((state) =>
    selectGeneratedIdeas(state),
  )

  const onChangeAbout = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    setAbout(event.target.value)
  }

  const onChangeTargetAudience = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    setTargetAudience(event.target.value)
  }

  const onGenerateIdea = (): void => {
    dispatch(
      generateIdeas({
        prompt: getPrompt(),
        cta: 'publish-ideas-contentIdeationWidget-generate-1',
      }),
    )
  }

  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault()

    if (!about || !targetAudience) return
    setPromptSettings({ about, targetAudience })
    onGenerateIdea()
  }

  React.useEffect(() => {
    const { about: savedAbout, targetAudience: savedTargetAudience } =
      getPromptSettings()

    if (!savedAbout || !savedTargetAudience) return

    setAbout(savedAbout)
    setTargetAudience(savedTargetAudience)
  }, [])

  return (
    <Flex gap="lg" direction="column">
      <Heading as="h2">Let&apos;s begin with a few questions 🪄</Heading>
      <form onSubmit={onSubmit}>
        <Label htmlFor="business-about">What is your business about?</Label>
        <Textarea
          value={about}
          placeholder="A training and fitness brand"
          onChange={onChangeAbout}
          id="business-about"
        />
        <Label htmlFor="business-target">What is your target audience?</Label>
        <Textarea
          value={targetAudience}
          placeholder="Busy working professionals worldwide"
          onChange={onChangeTargetAudience}
          id="business-target"
        />
        <Button
          size="large"
          type="submit"
          disabled={!about || !targetAudience}
          loading={generateIdeasLoading}
          className={styles.submitButton}
        >
          {generateIdeasLoading ? 'Generating…' : 'Generate Ideas'}
        </Button>
        {generateIdeasError && <ErrorMessage message={generateIdeasError} />}
      </form>
    </Flex>
  )
}

export { Questions }
